"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  ShareAndCopy: true
};
exports.ShareAndCopy = void 0;
var _ShareAndCopyDialog = require("./ShareAndCopyDialog");
Object.keys(_ShareAndCopyDialog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ShareAndCopyDialog[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ShareAndCopyDialog[key];
    }
  });
});
var _context = require("./context");
var _jsxRuntime = require("react/jsx-runtime");
const ShareAndCopy = props => {
  const {
    translations
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_context.TranslationsProvider, {
    value: translations,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ShareAndCopyDialog.ShareAndCopyDialog, {
      ...props
    })
  });
};
exports.ShareAndCopy = ShareAndCopy;
